/* eslint-disable no-console */
import { Widget } from "blue-widgets";

class CookieHandler extends Widget {
  constructor(el) {
    super(el);
    this.acceptBtn = this.el.querySelector("[data-accept-btn]");

    this.acceptBtn.addEventListener("click", this.handleClick);
  }

  handleClick = () => {
    // Disable button
    this.acceptBtn.setAttribute("disabled", "");

    // Send a POST request
    fetch("/umbraco/Surface/CookieBannerSurface/HideBanner", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        if (response.ok) {
          // Hide the cookie banner after successful acceptance
          this.disableBanner();
        } else {
          this.acceptBtn.removeAttribute("disabled");
          console.error("Error sending POST request. Status:", response.status);
        }
      })
      .catch((error) => {
        this.acceptBtn.removeAttribute("disabled");
        console.error("Error sending POST request:", error);
      });
  };

  disableBanner = () => {
    this.el.setAttribute("aria-hidden", true);
    this.el.classList.add("hide");

    const tabbableElements = this.el.querySelectorAll(
      "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    );
    const tabbableElementsArray = Array.from(tabbableElements);

    tabbableElementsArray.forEach((element) => {
      element.setAttribute("tabindex", -1);
    });
  };

  beforeRemove() {
    this.acceptBtn.removeEventListener("click", this.handleClick);
  }
}

export default CookieHandler;
